




















































import {Vue, Component, Prop} from 'vue-property-decorator';
import {GetSmsUsagesViewRequest} from 'supporter';
import {getSelectYears, getSelectMonths} from '@/utils/dateUtils';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import BasicRadioButton from '@/components/common/BasicRadioButton.vue';
import SmsTab from '@/components/manage/sms/SmsTab.vue';

@Component({
  components: {CompSelectBox, BasicRadioButton, SmsTab}
})
export default class SmsUsageListSearch extends Vue {
  @Prop({required: true}) private searchForm!: GetSmsUsagesViewRequest;
  @Prop({default: 0}) private mallNo!: number;
  private years: object[] = [];
  private months: object[] = [];
  private messageTypeOptions: object[] = [];
  private searchRequest = this.searchForm;

  private searchClick() {
    this.$emit('search');
  }
  private initSearchForm(): void {
    this.setSearchFormVal();
    this.setMessageTypeOptionsVal();
    this.$emit('change', this.searchRequest);
  }
  private setSearchFormVal(): void {
    this.searchRequest = {
      params: {
        mallNo: Number(this.$route.query.mallNo),
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        messageType: ''
      }
    };
  }
  private setMessageTypeOptionsVal(): void {
    this.messageTypeOptions = [
      {
        id: 'messageType_all',
        value: '',
        dispaly: this.$t('MANAGE_SMS_MESSAGETYPE_ALL')
      },
      {
        id: 'messageType_sms',
        value: 'SMS',
        dispaly: this.$t('MANAGE_SMS_MESSAGETYPE_SMS')
      },
      {
        id: 'messageType_lms',
        value: 'LMS',
        dispaly: this.$t('MANAGE_SMS_MESSAGETYPE_LMS')
      }
    ];
  }

  private mounted(): void {
    this.initSearchForm();
    this.years = getSelectYears(this.$t('COMMON_YEAR'));
    this.months = getSelectMonths(this.$t('COMMON_MONTH'));
  }
}
